export default __webpack_public_path__ + "fonts/7cdfc792d9231ae1ce8c6c9c0949af1b.svg";